import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Buildings, Waves } from "@phosphor-icons/react";

export default function HomeWhoHereForSection() {
  const [audience, setAudience] = useState(null);

  return (
    <section className="md-section" data-testid="who-here-for-section">
      <div className="md-container text-center">
        <div className="md-label-eyebrow mb-3">Who are you here for</div>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif fade-up max-w-4xl mx-auto" style={{ lineHeight: 1.05 }}>
          For the person you are, <span style={{ color: "var(--md-primary)" }}>for the person you&apos;re becoming</span>
        </h2>
        <p className="text-lg max-w-4xl mt-5 fade-up delay-2 mx-auto" style={{ color: "var(--md-text-soft)" }}>
          <span className="md-brand">MindDhara</span> helps you understand your brain, care for your mind, and navigate life
          <br className="hidden md:block" />
          {" "}with greater clarity, confidence, and ease through wellbeing, mentorship, and research.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-10 max-w-3xl mx-auto fade-up delay-3 text-left">
          <button onClick={() => setAudience("myself")} className={`md-card md-card-hover text-left ${audience === "myself" ? "ring-2" : ""}`} style={audience === "myself" ? { boxShadow: "0 0 0 2px var(--md-primary)" } : {}} data-testid="hero-myself-btn">
            <Waves size={32} weight="duotone" style={{ color: "var(--md-primary)" }} />
            <h3 className="text-2xl font-serif mt-4">For Me</h3>
            <p className="text-sm mt-2" style={{ color: "var(--md-text-soft)" }}>Therapy, brain health, mentorship, career development, or a free first conversation.</p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <Link to="/couch?source=home-hero-myself" className="btn-primary text-sm" data-testid="hero-myself-couch">Couch <ArrowRight size={14} weight="bold" /></Link>
              <Link to="/forward?source=home-hero-myself" className="btn-outline text-sm" data-testid="hero-myself-forward">Forward <ArrowRight size={14} weight="bold" /></Link>
            </div>
          </button>
          <button onClick={() => setAudience("org")} className={`md-card md-card-hover text-left ${audience === "org" ? "ring-2" : ""}`} style={audience === "org" ? { boxShadow: "0 0 0 2px var(--md-primary)" } : {}} data-testid="hero-organisation-btn">
            <Buildings size={32} weight="duotone" style={{ color: "var(--md-accent)" }} />
            <h3 className="text-2xl font-serif mt-4">For My Organisation</h3>
            <p className="text-sm mt-2" style={{ color: "var(--md-text-soft)" }}>Workshops and partnerships for schools, universities and corporate teams.</p>
            <div className="flex gap-3 mt-6 flex-wrap">
              <Link to="/organisations/corporate?source=home-hero-org" className="btn-primary text-sm" data-testid="hero-org-corporate">Corporate <ArrowRight size={14} weight="bold" /></Link>
              <Link to="/organisations/schools?source=home-hero-org" className="btn-outline text-sm" data-testid="hero-org-schools">Schools <ArrowRight size={14} weight="bold" /></Link>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
